import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor'; // https://www.npmjs.com/package/@kolkov/angular-editor

import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppData } from 'src/app/app.data';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent implements OnInit {

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<any> = new EventEmitter();

  public obj: any;
  public propertyNameHTML: string;
  public propertyNameText: string;
  public htmlContent = '';
  private navigateBackData:any[] = [];
  public isDisabled = false;
  private settings: Settings;
  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
     height: '100%',
     minHeight: '0',
     maxHeight: '100%',
     width: 'auto',
     minWidth: '0',
     translate: 'no',
     enableToolbar: true,
     showToolbar: false,
     placeholder: '',
     defaultParagraphSeparator: 'p',
     defaultFontName: 'Arial',
     defaultFontSize: '',
     fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
    uploadUrl: 'v1/image',
    sanitize: false,   // SET DOM sanitize
    toolbarPosition: 'top'
};



  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private appData: AppData,
    private appSettings: AppSettings
  ) {

    this.settings = appSettings.settings;

  }

  ngOnInit() {
    // this.appData.textEditorData: JSON.stringify({obj: treatment, paramHTML: 'Description_HTML', paramTEXT: 'Description'});
    const editorData = JSON.parse(this.appData.textEditorData);
    this.obj = editorData.obj;
    this.propertyNameHTML = editorData.paramHTML;
    this.propertyNameText = editorData.paramTEXT;
    this.htmlContent = this.obj[this.propertyNameHTML || ''] || '';
    this.navigateBackData = this.appData.navigateBackData;

    // if the id can be change after component initialized use this
    // this.hero$ = this.route.paramMap.pipe(
    //   switchMap((params: ParamMap) =>
    //     this.service.getHero(params.get('id')))
    // );

    // if you know that the component always initilized from other component use snapshot
    // this.returnID = +this.route.snapshot.paramMap.get('id');

  }

  onSave(event:any) {
    const el: HTMLElement | null = document.getElementById('editor');
    if (el) {
      if (this.propertyNameText) {
        this.obj[this.propertyNameText] = el.innerText;
      }
    }

    // get html
    const div: HTMLElement = document.createElement('div');
    div.innerHTML = this.htmlContent;

    this.obj[this.propertyNameHTML] = div.innerHTML;
    this.appData.textEditorData = JSON.stringify({obj: this.obj, paramHTML: this.propertyNameHTML, paramTEXT: this.propertyNameText});
    this.router.navigate(this.navigateBackData);

  }

  onCancel(event:any) {
    this.appData.textEditorData = '';
    this.router.navigate(this.navigateBackData);
  }
}
